import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { AppVersionGuardService } from '@services/app-version-guard.service';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private _matIconRegistry = inject(MatIconRegistry);
  private _domSanitizer = inject(DomSanitizer);
  private _appVersionGuardService = inject(AppVersionGuardService);

  constructor() {
    const cacheKey = this._appVersionGuardService.currentBuildId ?? Date.now();

    this._matIconRegistry.addSvgIconSetInNamespace(
      'nx',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/symbol-defs.svg?v=${cacheKey}`
      )
    );
  }
}
